import { MoneyfarmTheme } from './Moneyfarm';
export const Themes = {
    mf: MoneyfarmTheme,
};
//# sourceMappingURL=Themes.js.map